import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined';
import {
  getTableV2DetailBodyCellSx,
  getTableV2HeaderCellSx,
  tableV2DetailPanelTitleSx,
  tableV2DetailPanelWrapperSx,
  tableV2EmptyStateSx,
  tableV2TableSx,
} from '../../../components/v2/tableV2Styles';

const DETAIL_ROW_HEIGHT = 44;

const EquipamentosUnidadesDetail = ({
  unidades,
  tipoNome,
  modelo,
  canManage,
  onOpen,
  onDelete,
}) => {
  const headerCellSx = getTableV2HeaderCellSx(DETAIL_ROW_HEIGHT);
  const title = `Unidades · ${tipoNome || 'Equipamento'}${modelo ? ` · ${modelo}` : ''}`;

  if (!unidades || unidades.length === 0) {
    return (
      <Box sx={tableV2DetailPanelWrapperSx}>
        <Typography component="div" sx={tableV2DetailPanelTitleSx}>
          {title}
        </Typography>
        <Box sx={{ ...tableV2EmptyStateSx, py: 2, px: 2 }}>
          Nenhuma unidade neste grupo.
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={tableV2DetailPanelWrapperSx}>
      <Typography component="div" sx={tableV2DetailPanelTitleSx}>
        {title}
      </Typography>
      <Box sx={{ overflowX: 'auto', px: { xs: 0.5, sm: 1 }, pb: 0.5 }}>
        <Table
          size="medium"
          aria-label="Unidades do equipamento"
          sx={tableV2TableSx}
        >
          <TableHead>
            <TableRow hover={false}>
              <TableCell sx={headerCellSx}>Patrimônio</TableCell>
              <TableCell sx={headerCellSx}>Série</TableCell>
              <TableCell sx={headerCellSx}>SISANT</TableCell>
              <TableCell sx={headerCellSx}>Último Repasse</TableCell>
              <TableCell sx={{ ...headerCellSx, width: canManage ? 120 : 56 }} />
            </TableRow>
          </TableHead>
          <TableBody>
            {unidades.map((unidade, rowIndex) => {
              const cellSx = getTableV2DetailBodyCellSx(DETAIL_ROW_HEIGHT, rowIndex);
              return (
                <TableRow key={unidade.id} hover>
                  <TableCell sx={cellSx}>{unidade.numPatrimonio || '—'}</TableCell>
                  <TableCell sx={cellSx}>{unidade.numSerie || '—'}</TableCell>
                  <TableCell sx={cellSx}>{unidade.codigoSisant || '—'}</TableCell>
                  <TableCell sx={cellSx}>{unidade.ultimoRepasse || '—'}</TableCell>
                  <TableCell sx={cellSx}>
                    <IconButton
                      size="small"
                      aria-label={canManage ? 'Editar unidade' : 'Ver unidade'}
                      onClick={() => onOpen(unidade.id)}
                    >
                      {canManage ? (
                        <EditOutlinedIcon fontSize="small" />
                      ) : (
                        <VisibilityOutlinedIcon fontSize="small" />
                      )}
                    </IconButton>
                    {canManage && (
                      <IconButton
                        size="small"
                        aria-label="Excluir unidade"
                        onClick={() => onDelete(unidade.id)}
                      >
                        <DeleteOutlinedIcon fontSize="small" />
                      </IconButton>
                    )}
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </Box>
    </Box>
  );
};

EquipamentosUnidadesDetail.propTypes = {
  unidades: PropTypes.arrayOf(PropTypes.object),
  tipoNome: PropTypes.string,
  modelo: PropTypes.string,
  canManage: PropTypes.bool,
  onOpen: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};

EquipamentosUnidadesDetail.defaultProps = {
  unidades: [],
  tipoNome: undefined,
  modelo: undefined,
  canManage: false,
};

export default EquipamentosUnidadesDetail;
